var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtencilsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.668V30.0013C22 31.468 23.2 32.668 24.6667 32.668H30C30.7072 32.668 31.3855 32.387 31.8856 31.8869C32.3857 31.3868 32.6667 30.7085 32.6667 30.0013V20.668M27.3333 20.668V47.3346M46 38.0013V20.668C44.2319 20.668 42.5362 21.3703 41.286 22.6206C40.0357 23.8708 39.3333 25.5665 39.3333 27.3346V35.3346C39.3333 36.8013 40.5333 38.0013 42 38.0013H46ZM46 38.0013V47.3346",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtencilsIcon);
export default __webpack_public_path__ + "static/media/utencils-icon.c5304685ea6a7ab340947d21a4628c8f.svg";
export { ForwardRef as ReactComponent };